/**
 * @name AppDetail
 * @description Componente común con detalles de un empleado (avatar, nombre, detalle puesto/área/sucursal)
 * @author César Rivera
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { App, Typography } from '@styles';

const AppDetail = (props) => {
  const {
    app,
    appSize,
  } = props;

  return (
    <Styled.FlexBox>
        <Styled.AppBox>
          <App
            size={appSize ? appSize : 'xs'}
            src={app ? app : 'https://s3-us-west-1.amazonaws.com/ty-assets/icons/reconocimientos/aunporreconocer.png'}
          >
          </App>
        </Styled.AppBox>
    </Styled.FlexBox>
  );
};

AppDetail.propTypes = {
  // URL de la foto del empleado.
  app: PropTypes.string,
  // Tamaño de la foto del empleado.
  appSize: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.FlexBox = styled.div`
  display: flex;
  flex: 1;
`;

Styled.AppBox = styled.div`
  margin-right: 16px;
  align-self: center;
`;

export default AppDetail;